<footer class="site-footer">
  <div class="footer-top text-white">
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-sm-4 footer-col-4">
          <div class="widget ">
            <h4 class="m-b15"></h4>
            <div class="dez-separator-outer">
              <div class="dez-separator bg-white style-liner"></div>
            </div>
            <ul class="widget_getintuch">
              <li><i class="fa fa-phone"></i><strong class="text-white">Central Piloto:</strong>(591) 50850019 / Fax:
                (591-2)
                2312641</li>
            </ul>
            <ul class="widget_getintuch">
              <li><i class="fa fa-map-marker"></i><strong class="text-white">Dirección:</strong> Av. Mariscal Santa Cruz
                N° 1092 Casilla N° 12814
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 footer-col-4">
          <!--<div class="widget ">
            <h4 class="m-b15"></h4>
            <div class="dez-separator-outer"><div class="dez-separator bg-white style-liner"></div></div>
            <ul class="widget_getintuch">
              <li><i class="fa fa-mail-forward"></i><strong class="text-white">Email:</strong> contactanos@planificacion.gob.bo</li>
            </ul>
          </div>
          -->
          <div class="widget ">
            <h4 class="m-b15"></h4>
            <div class="dez-separator-outer">
              <div class="dez-separator bg-white style-liner"></div>
            </div>
            <ul class="">
              <li>
                <strong class="text-white">Encuéntranos en:</strong>
                <p>
                  <i class="fa fa-facebook "></i> - <a href="https://www.facebook.com/MinPlanificaOficial"
                    class="text-white">
                    facebook.com/MinPlanificaOficial</a>
                </p>
              </li>
              <li>
                <p>
                  <i class="fa fa-twitter"></i> - <a href="https://twitter.com/minplanifica" class="text-white">
                    twitter.com/minplanifica</a>
                </p>
              </li>
              <li>
                <p>
                  <i class="fa fa-youtube"></i> - <a href="https://youtube.com/channel/UCGtfeyglS4a4qcxpc87zoeg"
                    class="text-white">
                    MPD - MinPlanifica</a>
                </p>
              </li>

            </ul>
          </div>

        </div>
        <div class="col-md-4 col-sm-4 footer-col-4">

          <!--<div class="widget widget_gallery">
            <h4 class="m-b15">Entidades</h4>
            <div class="dez-separator-outer"><div class="dez-separator bg-white style-liner"></div></div>
            <ul>
              <li class="img-effect2"> <a href="javascript:void(0);"><img src="/assets/links/ine.png" alt=""></a> </li>
              <li class="img-effect2"> <a href="javascript:void(0);"><img src="/assets/links/fndr.png" alt=""></a> </li>
              <li class="img-effect2"> <a href="javascript:void(0);"><img src="/assets/links/udape.png" alt=""></a> </li>
              <li class="img-effect2"> <a href="javascript:void(0);"><img src="/assets/links/fps.png" alt=""></a> </li>
              <li class="img-effect2"> <a href="javascript:void(0);"><img src="/assets/links/fondesif.png" alt=""></a> </li>
              <li class="img-effect2"> <a href="javascript:void(0);"><img src="/assets/links/bdp.jpg" alt=""></a> </li>
              <li class="img-effect2"> <a href="javascript:void(0);"><img src="/assets/links/ademaf.png" alt=""></a> </li>
              <li class="img-effect2"> <a href="javascript:void(0);"><img src="/assets/links/planvida.png" alt=""></a> </li>
            </ul>
          </div>
          <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
            <agm-marker [latitude]="lat" [longitude]="lng" iconUrl="/assets/marker1.png">
              <agm-snazzy-info-window [maxWidth]="200" [closeWhenOthersOpen]="true" [isOpen]="true">
                <ng-template>
                  Ministerio de Planificación del Desarrollo
                </ng-template>
              </agm-snazzy-info-window>
            </agm-marker>
          </agm-map>
-->
          <div class="widget ">
            <h4 class="m-b15"></h4>
            <div class="dez-separator-outer">
              <div class="dez-separator bg-white style-liner"></div>
            </div>
            <ul class="widget_getintuch">
              <li><i class="fa fa-mail-forward"></i><strong class="text-white">Email:</strong>
                contactanos@planificacion.gob.bo</li>
            </ul>
          </div>
        </div>

      </div>
      <div class="footer-info-box clearfix p-tb30 p-lr15">
        <div class="col-md-9 col-sm-9">
          <p class="text-left">Copyright © MPD - Unidad de Innovaci&oacute;n Tecnol&oacute;gica 2021</p>
        </div>
        <div class="col-md-3 col-sm-3" style="text-align: right;">
          <hr>
        </div>
        <!-- <div class="col-md-5 col-sm-5">
          <div class="text-right">
            <ul class="dez-social-icon border">
              <li><a class="fa fa-envelope text-primary" href="https://mail.planificacion.gob.bo/owa"></a></li>
              <li><a class="fa fa-facebook text-primary" href="https://www.facebook.com/MinPlanificaOficial"></a></li>
              <li><a class="fa fa-twitter text-primary" href="https://twitter.com/minplanifica"></a></li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</footer>
<button class="scroltop fa fa-arrow-up"></button>


// WEBPACK FOOTER //
// ./src/app/layouts/footer/footer.component.html